import React from "react";

const Support = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Support Specialist</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Support Specialist perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Support Specialist</b> is focused on providing heavy firepower
          and crowd control while offering critical team support with their
          ability to repair and weld up defenses. The Support Specialist perk
          emphasizes using shotguns and maintaining fortifications.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Support Specialist has access to a variety of
          shotguns. These weapons excel at dealing massive damage up close and
          clearing groups of Zeds with powerful bursts.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <div className="bonusList">
            <ul>
              <li>Bonuses for Support Specialist weapons:</li>
              <ul>
                <li>Increase in damage;</li>
                <li>Increase in penetration;</li>
                <li>Increase in fire speed;</li>
                <li>Increase in reload speed;</li>
                <li>Increase in amount ammunition magazines;</li>
                <li>Increase in pickup amount of ammunition;</li>
                <li>Discount on ammunition;</li>
                <li>Reduced weapon price;</li>
              </ul>
              <li>General bonuses:</li>
              <ul>
                <li>Increase in grenade damage;</li>
                <li>Increase in weld speed;</li>
                <li>Increase in carry weight;</li>
                <li>Increase in recoil control;</li>
              </ul>
            </ul>
          </div>
          <b>Team Role</b>: Support Specialists are effective at both dealing
          damage and providing utility by keeping doors secured. They play an
          essential role in holding off enemy waves and creating defensive
          positions for the team.
        </div>
      </div>
    </div>
  );
};

export default Support;
